import React from "react";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";
import { Database } from "@/integrations/supabase/types";
import { RichTextDisplay } from "@/components/ui/rich-text-display";
import { isMarkdown, markdownToHtml } from "@/utils/markdownToHtml";

type PolicyVersion = Database["public"]["Tables"]["policy_versions"]["Row"];

interface PolicyVersionPreviewProps {
  isOpen: boolean;
  onClose: () => void;
  version: PolicyVersion | null;
}

const POLICY_TYPE_LABELS: Record<string, string> = {
  privacy_policy: "Privacy Policy",
  terms_acceptance: "Terms of Service",
  cookies: "Cookie Policy",
  marketing: "Marketing Consent",
};

export const PolicyVersionPreview: React.FC<PolicyVersionPreviewProps> = ({
  isOpen,
  onClose,
  version,
}) => {
  if (!version) return null;

  // Convert Markdown to HTML if needed for backward compatibility
  const content = React.useMemo(() => {
    if (isMarkdown(version.content)) {
      return markdownToHtml(version.content);
    }
    return version.content;
  }, [version.content]);

  return (
    <Dialog open={isOpen} onOpenChange={onClose}>
      <DialogContent className="max-w-4xl max-h-[90vh] overflow-y-auto">
        <DialogHeader>
          <DialogTitle>
            {POLICY_TYPE_LABELS[version.policy_type]} - {version.version}
          </DialogTitle>
          <DialogDescription>
            Effective Date: {version.effective_date ? new Date(version.effective_date).toLocaleDateString() : "Not set"}
          </DialogDescription>
        </DialogHeader>
        <div className="mt-4">
          <RichTextDisplay 
            content={content}
            className="prose prose-sm max-w-none"
            fallbackText="No content available."
          />
        </div>
      </DialogContent>
    </Dialog>
  );
};

